import { render, staticRenderFns } from "./addFamily.vue?vue&type=template&id=5c55e058&scoped=true"
import script from "./addFamily.vue?vue&type=script&lang=js"
export * from "./addFamily.vue?vue&type=script&lang=js"
import style0 from "./addFamily.vue?vue&type=style&index=0&id=5c55e058&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55e058",
  null
  
)

export default component.exports